// src/hooks/useResultsTools.js
import { useCallback, useState, useLayoutEffect, useEffect } from 'react'
import { getTopLoads as apiGetTopLoads, tell } from '../api/auth'
import { useLoads } from '../context/LoadsContext'

export function useResultsTools({ navigate, toast, loadRefs }) {
  const { loads, updateLoads } = useLoads()

  const [topSummary, setTopSummary]   = useState('')
  const [highlightId, setHighlightId] = useState(null)
  const [expandedId, setExpandedId]   = useState(null)
  const [loadingTop, setLoadingTop]   = useState(false)
  const [topLoadsData, setTopLoadsData] = useState([])

  // existing scrolling/highlight effect
  useLayoutEffect(() => {
    console.log("highlightId",highlightId)
    if (!highlightId) return
    const el = loadRefs.current[highlightId]
    if (!el) return

    el.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }, [highlightId, loadRefs])

  const fetchTop = useCallback(async () => {
    console.log("fetchTop started");
    setLoadingTop(true)
    try {
      let loadsLs = null
      if (loads.length === 0){
        loadsLs = JSON.parse(localStorage.getItem('loads_data')).loads;
      } else {
        loadsLs = loads;
      }
      const driverId = localStorage.getItem('driverId')
      const { data } = await apiGetTopLoads(driverId)
      const topList = Array.isArray(data.loads) ? data.loads : []
      // write to local storage
      localStorage.setItem('topLoadsData', JSON.stringify(data))
      console.log("Top list received:", topList);
      setTopLoadsData(topList)
      
      if (topList.length > 0) {
        setTopSummary(data.overall_summary || topList[0].overall_summary || '')
        
        // Process the received data
        // First find the load with the highest score
        let highestScoreLoad = topList[0]
        for (let i = 1; i < topList.length; i++) {
          if (topList[i].overall.score > highestScoreLoad.overall.score) {
            highestScoreLoad = topList[i]
          }
        }
        console.log("highestScoreLoad", highestScoreLoad)
        
        // Update the loads with top information
        const updatedLoads = [...loadsLs]
        let topLoadId = null;
        
        console.log("Original loads structure:", loadsLs.slice(0, 2));
        
        for (const load of updatedLoads) {
          // Find if this load has top information
          const topInfo = topList.find(topLoad => topLoad.matchId === load.id)
          console.log("Checking load:", { loadId: load.id, hasTopInfo: !!topInfo });
          
          if (topInfo) {
            // Add top information to the load
            load.topInfo = topInfo
            console.log("Added topInfo to load:", { 
              loadId: load.id, 
              topInfo: {
                matchId: topInfo.matchId,
                score: topInfo.overall?.score,
                summary: topInfo.overall_summary
              }
            });
            
            // If this is the highest scoring load, store its ID
            if (topInfo.matchId === highestScoreLoad.matchId) {
              topLoadId = load.id;
              console.log("Found highest scoring load:", { 
                loadId: load.id, 
                matchId: topInfo.matchId,
                score: topInfo.overall?.score 
              });
            }
          } else {
            // Remove any existing top information
            delete load.topInfo
          }
        }
        
        console.log("Updated loads structure:", updatedLoads.slice(0, 2));
        
        // If we have access to updateLoads from context, use it
        if (typeof updateLoads === 'function') {
          console.log("Updating loads with top info");
          updateLoads(updatedLoads)
          
          // Set highlight and expand after loads are updated
          if (topLoadId) {
            console.log("Setting highlight and expand for:", topLoadId);
            setTimeout(() => {
              setHighlightId(topLoadId)
              setExpandedId(topLoadId)
            }, 100);
          }
        }
      }

      return data
    } catch (error) {
      console.error("Error in fetchTop:", error);
      toast({ 
        title: 'Error fetching top loads', 
        status: 'error',
        description: error.message
      })
      return { loads: [], message: 'Error fetching top loads' }
    } finally {
      setLoadingTop(false)
    }
  }, [loads, updateLoads, toast])

  const toggleExpand = useCallback(id => {
    setExpandedId(prev => (prev === id ? null : id))
  }, [])

  // MODIFIED - Now passes the complete load data to the booking page
  const clickBookLoadTool = useCallback(({ id }) => {
    // Find the load by ID
    //check if id is a pure number and then check if it is less than the length of loads in a nested check
    let loadData = null
    let loadsLs = null
    console.log(id)
    console.log(loads)
    console.log("summer")
    if (loads.length === 0){
      loadsLs = JSON.parse(localStorage.getItem('loads_data')).loads;
    } else {
      loadsLs = loads;
    }
    if (!/^\d+$/.test(id)) {
      loadData = loadsLs.find(load => load.id === id)
      console.log(loadData)
      console.log(loadsLs)
      console.log(id)
      console.log("mama")
    }else if (id < loadsLs.length){
      if (id === 0){
        loadData = loadsLs[id]
      }else{
        loadData = loadsLs[id-1]//.find(load => load.id === id)
      }
      console.log(loadData)
      console.log(loadsLs)
      console.log(id)
      console.log("mama")
    } 
    if (loadData) {
      // Using tell API tell the backend what id the user has clicked
      const driverId = localStorage.getItem('driverId')
      tell(driverId, "selected_load_id", loadData.id);
      // Navigate to the load booking page with the load data
      navigate(`/booking/${id}`, { 
        state: { loadData } 
      })
      return { id, loadData, success: true }
    } else {
      toast({
        title: "Load not found",
        status: "error",
        duration: 3000,
        isClosable: true,
      })
      return { id, success: false }
    }
  }, [navigate, loads, toast])

  // ←– MODIFIED –– scrollToLoadTool now writes into localStorage
  const scrollToLoadTool = useCallback(({ index }) => {
    const loadsData = JSON.parse(localStorage.getItem('loads_data'))
    console.log("in scrollToLoadTool")
    console.log(index)
    console.log(loads)
    // if (i < 0 || i >= loads.length) {
      //   toast({ title: 'Invalid load index', status: 'error' })
      //   return null
      // }
      // store the index; Results.jsx will pick it up and actually scroll
      localStorage.setItem('scrollToLoadIndex', index)
      // check if index is a pure number and then check if it is less than the length of loads in a nested check
      let loadData = null
      if (!/^\d+$/.test(index)) {
        loadData = loadsData.loads.find(load => load.id === index)
      }else{ 
        // index is a string so convert it to a number
        let index2 = parseInt(index, 10)
        if (index2 > 0){
          index2 = index2 - 1;
        }
        if (index2 < loadsData.loads.length){
          loadData = loadsData.loads[index2]
          console.log(index2)
          console.log(loadsData)
          console.log(loads[index2])
          console.log(loadsData.loads[index2])
      }
    }
    return loadData
  }, [loads, toast])

  const fetchTopTell = useCallback(() => {
    // Set the flag to trigger fetchTop in Results.jsx
    // check if loads_data from local storage is empty
    // check loads_data exists in local storage
    if (localStorage.getItem('loads_data')){
      if (JSON.parse(localStorage.getItem('loads_data')).loads.length > 0){
        localStorage.setItem('fetchTopLoads', 'true')
        return { success: true, message: 'Top loads will fetched and shown in the screen now can do top_loads_data and then scrollToLoad' }
      }else{
        return { success: false, message: 'Use performSearch first, then getTopLoads and then top_loads_data and then scrollToLoad' }
      }
    }else{
      return { success: false, message: 'Use performSearch first, then getTopLoads and then top_loads_data and then scrollToLoad' }
    }
  }, [])

  // This method polls localStorage until topLoadsData is available
  const getTopLoadsData = useCallback(() => {
    const poll = () => {
      const storedData = localStorage.getItem('topLoadsData')
      if (!storedData) {
        return new Promise(resolve => setTimeout(() => resolve(poll()), 100))
      }
      return Promise.resolve(JSON.parse(storedData))
    }
    return poll()
  }, [])


  return {
    loads,
    topSummary,
    highlightId,
    expandedId,
    loadingTop,
    topLoadsData,

    fetchTop,
    toggleExpand,

    getTopLoadsTool: fetchTopTell,//fetchTopTell,
    getTopLoadsData,
    scrollToLoadTool,
    clickBookLoadTool,

    // expose setters so Results.jsx can trigger the layoutEffect
    setHighlightId,
    setExpandedId,
  }
}